import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AddUserTableModal({ data, columns }) {
  const { t } = useTranslation();

  return (
    <>
      {columns?.map((column, idx) => {
        return (
          <Typography>
            <strong>{t(column?.trsText)}:</strong>{" "}
            {column?.id === "user-id"
              ? data?.user_id
              : column?.id === "user-name"
                ? data?.agent_name
                : column?.id === "email"
                  ? data?.email
                  : column?.id === "agent-id"
                    ? data?.agent_id
                    : column?.id === "branch-name"
                      ? data?.branch_name
                      : ""}
          </Typography>
        );
      })}
    </>
  );
}
